export const formatBitrate = (bitrate: number): string => {
  if (bitrate >= 1000) {
    return `${parseFloat((bitrate / 1000).toFixed(2))}M`;
  }
  return `${bitrate}K`;
};
